import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import API from "../../api/api";
import { setUser } from "../../store/userSlice";

import "../../style/admin-login.css";

export default function AdminLogin() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await API.post("/admin/login", form);

      // ✅ Save token to localStorage
      localStorage.setItem("grgpt_token", res.data.token);

      // ✅ Save admin user into Redux
      dispatch(setUser(res.data.user));

      navigate("/admin");

    } catch (err) {
      setError(err.response?.data?.message || "Admin login failed");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="admin-login-page">
      <div className="admin-login-card">

        <h2>Admin Login</h2>

        {error && (
          <div className="admin-login-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>

          <label>Email</label>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <label>Password</label>
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <button
            type="submit"
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login as Admin"}
          </button>

        </form>

        <div className="admin-login-footer">
          <span>Back to user login?</span>
          <Link to="/login">User Login</Link>
        </div>

      </div>
    </div>
  );
}